export const getFDate = (d) => {
   let date = !d ? new Date() : new Date(d);
    const month = date.getMonth() + 1
    const day = date.getDate()
    return `${date.getFullYear()}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`
}

export const formatedDate = (d) => {
   //recebe aaaa-mm-dd e retorna dd/mm/aaaa
   const date = d.split('-')
   return `${date[2]}/${date[1]}/${date[0]}`
 }
export const americanDate = (d) => {
   //recebe dd/mm/aaaa e retorna aaaa-mm-dd
   const date = d.split('/')
   return `${date[2]}-${date[1]}-${date[0]}`
 }